import { ButtonGroup, Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { ButtonHeading, VerticalTitle } from "../../../Constants/Constants";
import { VerticalText } from "../../../Data/ButtonsData/GroupButtonData";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { CommonDropdown } from "../Common/CommonDropdown";

export const VerticalButtonGroup = () => {
  return (
    <Col lg="6">
      <Card className="height-equal vertical-btn-group">
        <CommonCardHeader headClass="card-no-border pb-0" title={VerticalTitle} span={VerticalText} tag />
        <CardBody className="btn-group-wrapper">
          <ButtonGroup vertical>
            <Btn color="primary">{ButtonHeading}</Btn>
            <Btn color="secondary">{ButtonHeading}</Btn>
            <ButtonGroup>
              <CommonDropdown color="success" className="b-r-0 text-white" />
            </ButtonGroup>
            <Btn color="info">{ButtonHeading}</Btn>
            <Btn color="warning">{ButtonHeading}</Btn>
            <CommonDropdown color="danger" className="b-r-0 text-white" />
            <CommonDropdown color="light" className="b-r-0"/>
          </ButtonGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
